export default {
    doesApplicantOwnOperateOrLeaseAircraftWatercraft: 'No',
    havePastPresentOrDiscontinuedOperations: 'No',
    anyWorkPerformedUndergroundOrAbove15Feet: 'No',
    anyWorkPerformedOnBargesVesselsDocksBridgeOverWater: 'No',
    isApplicantEngagedInAnyOtherTypeOfBusiness: 'No',
    areSubContractorsUsed: {
        chosen: 'No',
        details: null,
        detailsFieldName: '% of work subcontracted'
    },
    anyWorkSubletWithoutCertificatesOfInsurance: 'No',
    isWrittenSafetyProgramInOperation: 'No',
    anyGroupTransportationProvided: 'No',
    anyEmployeesUnder16OrOver60YearsOfAge: 'No',
    anySeasonalEmployees: 'No',
    isThereAnyVolunteerOrDonatedLabor: {
        chosen: 'No',
        details: null,
        detailsFieldName: 'Please specify'
    },
    anyEmployeesWithPhysicalHandicaps: 'No',
    doEmployeesTravelOutOfState: {
        chosen: 'No',
        details: null,
        detailsFieldName: 'Indicate state(s) of travel and frequency'
    },
    areAthleticTeamsSponsored: 'No',
    arePhysicalsRequiredAfterOffersOfEmploymentAreMade: 'No',
    anyOtherInsuranceWithThisInsurer: 'No',
    anyPriorCoverageDeclinedCancelledOrNonRenewedInTheLastThreeYears: 'No',
    areEmployeeHealthPlansProvided: 'No',
    doAnyEmployeesPerformWorkForOtherBusinessesOrSubsidiaries: 'No',
    doYouLeaseEmployeesToOrFromOtherEmployers: 'No',
    doAnyEmployeesPredominantlyWorkAtHome: {
        chosen: 'No',
        details: null,
        detailsFieldName: '# of Employees'
    },
    anyTaxLiensOrBankruptcyWithinTheLastFiveYears: {
        chosen: 'No',
        details: null,
        detailsFieldName: 'Please specify'
    },
    anyUndisputedAndUnpaidWorkersCompensationPremiumDueFromYouOrCommonlyManagedOrOwnedEnterprises: {
        chosen: 'No',
        details: null,
        detailsFieldName: 'Explain including entity name(s) and policy number(s)'
    }
};
  